/* Dark/light/system mode context. Split from ThemeProvider to satisfy ESLint react-refresh. */

import { createContext } from "react";

export type ThemeMode = "dark" | "light" | "system";

export interface ThemeProviderState {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
}

const initialState: ThemeProviderState = {
  theme: "system",
  setTheme: () => null,
};

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialState);
